import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            网址分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            十大分类，精准导航，让您快速找到目标网站
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-xl p-5 md:p-6 text-center transition-all duration-200 hover:bg-primary-50/30 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}